<template>
    <div id="">
        <vue-headful :title="pageTitle"/>
        <div class="body-wrapper">
            <main class="w-100 vh-100 d-flex">
                <div class="container-fluid d-flex flex-column justify-content-center align-items-center">
                    <loading-animation class="loading" v-show="status === 'loading'"></loading-animation>

                    <div v-show="status === 'loaded'">
                        <b-row class="mb-5">
                            <b-col>
                                <h5 class="text-center">
                                    {{
                                    $t("Egregio {email} sei sicuro di volere richiedere la chiusura dell’accesso all’evento \"{titolo}\" tramite il tuo indirizzo email?",
                                    {email: this.email, titolo: this.event.Titolo})
                                    }}
                                </h5>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col sm="6" class="text-center">
                                <b-button variant="primary" class="btn-rikorda1" @click="disableEventEmail">
                                    {{ $t("Si - Chiudi l’accesso con il mio indirizzo email") }}
                                </b-button>
                            </b-col>
                            <b-col sm="6" class="text-center">
                                <b-button variant="danger" class="btn-rikorda1" @click="enableEventEmail">
                                    {{ $t("No - Voglio continuare ad accedere") }}
                                </b-button>
                            </b-col>
                        </b-row>
                    </div>

                    <div v-show="status === 'disabled'">
                        <b-row>
                            <b-col>
                                <h5 class="text-center">
                                    {{ $t("L’accesso è stato chiuso come richiesto")}}
                                </h5>
                            </b-col>
                        </b-row>
                    </div>

                    <div v-show="status === 'enabled'">
                        <b-row>
                            <b-col>
                                <h5 class="text-center">
                                    {{ $t("Puoi continuare ad accedere")}}
                                </h5>
                            </b-col>
                        </b-row>
                    </div>

                    <div v-show="status === 'error'">
                        <b-row>
                            <b-col>
                                <h5 class="text-center text-danger">
                                    {{ $t("Ops! Qualcosa è andato storto...")}}
                                </h5>
                            </b-col>
                        </b-row>
                    </div>
                </div>
            </main>
        </div>
    </div>
</template>

<script>
    import LoadingAnimation from "../components/LoadingAnimation"

    export default {
        name: "DisableEmail",

        components: {
            LoadingAnimation
        },

        data() {
            return {
                status: "",
                pageTitle: null,
                idEventiEmail: "",
                event: {},
                email: ""
            };
        },

        mounted() {
            this.idEventiEmail = this.$route.params.idEventiEmail;
            this.load();
        },

        methods: {
            load() {
                this.status = "loading";
                this.$api.getEventEmailData(this.idEventiEmail)
                    .then((response) => {
                        this.event = response.event;
                        this.email = response.email;
                        this.status = "loaded";
                    })
                    .catch(() => {
                        this.status = "error";
                    });
            },

            disableEventEmail() {
                this.status = "loading";
                this.$api.disableEventEmail(this.idEventiEmail)
                    .then((response) => {
                        this.status = "disabled";
                    })
                    .catch(() => {
                        this.status = "error";
                    });
            },

            enableEventEmail() {
                this.status = "loading";
                setTimeout(() => {
                    this.status = "enabled";
                }, 150);
            }
        }
    };
</script>

<style scoped>
    .loading {
        position: absolute;
        top: 50%;
        left: calc(50% - 41px);
    }
</style>
